


<div class="seller-page">
  <h1>Mes fournisseurs ({{dealerData.myProviders!.length}})</h1>
  <div class="buttons-section">
    <button mat-button (click)="goToProviderSearch()" class="cta-button"><mat-icon>search</mat-icon>Rechercher fournisseurs</button>
  </div>

  @if ((dealerData.myProviders == undefined ) || dealerData.myProviders!.length === 0 ) {
    <h6>
      <br />
      Aucun fournisseur
    </h6>
  }

  <app-dealers
    [fetchingResults]="(fetchingResults$ | async)!"
    [dealers]="dealerData.myProviders"
    >
  </app-dealers>

</div>

